import {
  FETCH_TEST_STATUS_COUNT_LOADING,
  FETCH_TEST_STATUS_COUNT_SUCCESS,
  FETCH_TEST_STATUS_COUNT_FAILED,
  SET_SELECTED_TEST_STATUS,
  CLEAR_TEST_STATUS_COUNT
} from "../actionTypeConstants/lambdaTestSidebarTestListConstant";

import createRestApiClient from "../../utility/createRestApiClient";
import { getApiBaseUrl, isSharingRoute } from "../../utility/utilityFunctions";
import { getCookieData } from "../../utility/cookieHandler/handler";
import cloneDeep from "lodash/cloneDeep";

export const getTestStatusCount = (filter, shareId) => {
  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let queryString = "";
  let filterToApply = cloneDeep(filter);

  if (filter) {
    let browserFilter = filterToApply["browser"];
    if (browserFilter && browserFilter?.length > 0) {
      const isEdgeAppliedIndex = browserFilter.findIndex(
        name => name === "edge"
      );
      if (isEdgeAppliedIndex > -1) {
        filterToApply["browser"][isEdgeAppliedIndex] = "MicrosoftEdge";
      }
    }

    // don't filter by status if the user has selected any status since it will remove other status options on ui
    delete filterToApply["status"];

    Object.keys(filterToApply).forEach(function(filterKey) {
      if (filterToApply[filterKey]) {
        if (filterToApply[filterKey] instanceof Array) {
          if (filterToApply[filterKey]?.length > 0) {
            if (filterKey === "range" && !filterToApply.filterBy) {
              queryString = `${queryString}&${filterKey}=${filterToApply[
                filterKey
              ].join(",")}&filterBy=range`;
            } else {
              queryString = `${queryString}&${filterKey}=${filterToApply[
                filterKey
              ].join(",")}`;
            }
          }
        }
        if (
          typeof filterToApply[filterKey] === "string" ||
          filterToApply[filterKey] instanceof String
        ) {
          if (filterToApply[filterKey].trim() !== "") {
            if (filterKey === "searchText") {
              queryString = `${queryString}&${filterKey}=testName:${encodeURIComponent(
                filterToApply[filterKey]
              )}`;
            } else {
              queryString = `${queryString}&${filterKey}=${encodeURIComponent(
                filterToApply[filterKey]
              )}`;
            }
          }
        }
      }
    });
  }

  let types = [
    FETCH_TEST_STATUS_COUNT_LOADING,
    FETCH_TEST_STATUS_COUNT_SUCCESS,
    FETCH_TEST_STATUS_COUNT_FAILED
  ];

  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token && !isSharingRoute()) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }

  let headers =
    isSharingRoute() && shareId
      ? {
          "x-ml-auth": shareId,
          "x-ml-user": "sharing-client"
        }
      : { Authorization: `Bearer ` + access_token };

  if (isSharingRoute() && shareId) {
    queryString += `&shareId=${shareId}`;
  }

  let endPoint = `${baseURL}/api/v2/test?timezone=null&includeCreated=0&caps=1&testStatusCount=true&disableTestList=true${queryString}`;

  return {
    types: types,
    promise: () =>
      apiClient.get(`${endPoint}`, {
        headers: headers
      })
  };
};

export const setSelectedTestStatus = selectedTestStatus => {
  return dispatch =>
    dispatch({
      type: SET_SELECTED_TEST_STATUS,
      payload: selectedTestStatus
    });
};

export const clearTestStatusCount = () => {
  return dispatch =>
    dispatch({
      type: CLEAR_TEST_STATUS_COUNT
    });
};
